var _defs, _rect, _g, _g2, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePlay32D7Baa8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 135,
    height: 40,
    viewBox: "0 0 135 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.915,
    y1: 6.614,
    x2: -0.383,
    y2: 5.945,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.076,
    y1: 17.098,
    x2: -1.305,
    y2: 17.098,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.862,
    y1: 10.863,
    x2: -0.501,
    y2: 9.093,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.188,
    y1: 13.583,
    x2: 0.421,
    y2: 12.793,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Get_it_on_google_play",
    "data-name": "Get it on google play",
    transform: "translate(-10 -10)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_131",
    "data-name": "Rectangle 131",
    width: 135,
    height: 40,
    rx: 5,
    transform: "translate(10 10)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M140,10.8a4.2,4.2,0,0,1,4.2,4.2V45a4.2,4.2,0,0,1-4.2,4.2H15A4.2,4.2,0,0,1,10.8,45V15A4.2,4.2,0,0,1,15,10.8H140m0-.8H15a5.015,5.015,0,0,0-5,5V45a5.015,5.015,0,0,0,5,5H140a5.015,5.015,0,0,0,5-5V15a5.015,5.015,0,0,0-5-5Z",
    fill: "#a6a6a6"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M57.418,20.243a2.709,2.709,0,0,1-.745,2,2.908,2.908,0,0,1-2.2.888,3.152,3.152,0,0,1-2.208-5.367,3.018,3.018,0,0,1,2.208-.9,3.106,3.106,0,0,1,1.232.251,2.468,2.468,0,0,1,.938.671l-.527.527a2.029,2.029,0,0,0-1.643-.711,2.32,2.32,0,0,0-2.33,2.4,2.36,2.36,0,0,0,4.006,1.727,1.892,1.892,0,0,0,.5-1.216H54.469v-.72h2.908A2.557,2.557,0,0,1,57.418,20.243Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M62.028,17.737H59.295v1.9h2.464v.72H59.295v1.9h2.733V23h-3.5V17h3.5Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M65.279,23h-.772V17.737H62.832V17h4.123v.737H65.279Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M69.938,23V17h.77v6Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M74.128,23h-.771V17.737H71.681V17H75.8v.737H74.128Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M83.609,22.225a3.116,3.116,0,0,1-4.4,0,3.242,3.242,0,0,1,0-4.45,3.106,3.106,0,0,1,4.4,0,3.232,3.232,0,0,1,0,4.446Zm-3.83-.5a2.308,2.308,0,0,0,3.26,0,2.556,2.556,0,0,0,0-3.444,2.308,2.308,0,0,0-3.26,0,2.559,2.559,0,0,0,0,3.444Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M85.575,23V17h.939l2.916,4.667h.033l-.033-1.156V17H90.2v6h-.8l-3.051-4.894h-.033l.033,1.157V23Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M78.136,31.752A4.253,4.253,0,1,0,82.4,36.005,4.192,4.192,0,0,0,78.136,31.752Zm0,6.83a2.584,2.584,0,1,1,2.4-2.577A2.46,2.46,0,0,1,78.136,38.582Zm-9.313-6.83a4.253,4.253,0,1,0,4.269,4.253A4.192,4.192,0,0,0,68.823,31.752Zm0,6.83a2.584,2.584,0,1,1,2.4-2.577A2.46,2.46,0,0,1,68.823,38.582ZM57.744,33.057v1.8h4.317a3.765,3.765,0,0,1-.982,2.271,4.42,4.42,0,0,1-3.335,1.321,4.8,4.8,0,0,1,0-9.6A4.6,4.6,0,0,1,61,30.141l1.273-1.273a6.3,6.3,0,0,0-4.527-1.821,6.606,6.606,0,1,0,0,13.211A6.036,6.036,0,0,0,62.351,38.4a5.962,5.962,0,0,0,1.563-4.221,5.829,5.829,0,0,0-.1-1.127Zm45.308,1.4a3.953,3.953,0,0,0-3.641-2.706A4.041,4.041,0,0,0,95.4,36.005a4.162,4.162,0,0,0,4.221,4.253,4.23,4.23,0,0,0,3.544-1.885l-1.45-.967a2.43,2.43,0,0,1-2.094,1.176,2.165,2.165,0,0,1-2.063-1.288l5.687-2.353Zm-5.8,1.418A2.333,2.333,0,0,1,99.475,33.4a1.645,1.645,0,0,1,1.579.9ZM92.629,40H94.5V27.5H92.629Zm-3.062-7.3H89.5a2.948,2.948,0,0,0-2.239-.95,4.257,4.257,0,0,0,0,8.506,2.9,2.9,0,0,0,2.239-.967h.064V39.9c0,1.627-.869,2.5-2.271,2.5a2.354,2.354,0,0,1-2.143-1.515l-1.627.677a4.053,4.053,0,0,0,3.77,2.513c2.191,0,4.044-1.289,4.044-4.43V32.009H89.567Zm-2.142,5.88a2.587,2.587,0,0,1,0-5.155A2.4,2.4,0,0,1,89.7,36.021,2.376,2.376,0,0,1,87.425,38.582ZM111.806,27.5h-4.471V40H109.2V35.264h2.606a3.888,3.888,0,1,0,0-7.765Zm.048,6.025H109.2V29.239h2.654a2.143,2.143,0,1,1,0,4.285Zm11.532-1.795a3.505,3.505,0,0,0-3.33,1.913l1.657.692a1.768,1.768,0,0,1,1.705-.917,1.8,1.8,0,0,1,1.962,1.609v.128a4.127,4.127,0,0,0-1.946-.482c-1.785,0-3.6.981-3.6,2.814a2.889,2.889,0,0,0,3.1,2.751,2.633,2.633,0,0,0,2.381-1.223h.064v.965h1.8V35.186C127.181,32.967,125.525,31.729,123.386,31.729Zm-.225,6.851c-.612,0-1.464-.305-1.464-1.061,0-.965,1.061-1.335,1.978-1.335a3.329,3.329,0,0,1,1.7.418A2.262,2.262,0,0,1,123.161,38.58ZM133.743,32l-2.139,5.42h-.064L129.32,32h-2.01l3.329,7.575-1.9,4.214h1.946L135.818,32Zm-16.807,8H118.8V27.5h-1.866Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M20.435,17.538a2.007,2.007,0,0,0-.462,1.405V41.059a2.005,2.005,0,0,0,.462,1.405l.074.072L32.9,30.147v-.292L20.509,17.465Z",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M37.028,34.279,32.9,30.147v-.292l4.131-4.131.093.054,4.893,2.78c1.4.794,1.4,2.093,0,2.887l-4.893,2.78Z",
    fill: "url(#linear-gradient-2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M37.122,34.225,32.9,30,20.435,42.464a1.627,1.627,0,0,0,2.079.061l14.608-8.3",
    fill: "url(#linear-gradient-3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M37.122,25.777l-14.608-8.3a1.627,1.627,0,0,0-2.079.061L32.9,30Z",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M37.029,34.132,22.514,42.379a1.665,1.665,0,0,1-2,.011h0l-.075.074h0l.074.073h0a1.665,1.665,0,0,0,2-.011l14.608-8.3Z",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M20.435,42.318a2.005,2.005,0,0,1-.462-1.405v.147a2,2,0,0,0,.462,1.4l.075-.074Z",
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M42.015,31.3l-4.986,2.833.093.093,4.893-2.78A1.755,1.755,0,0,0,43.063,30h0A1.861,1.861,0,0,1,42.015,31.3Z",
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M22.514,17.623l19.5,11.08A1.861,1.861,0,0,1,43.063,30h0a1.753,1.753,0,0,0-1.048-1.444l-19.5-11.08c-1.4-.794-2.541-.134-2.541,1.466v.147C19.973,17.489,21.116,16.829,22.514,17.623Z",
    fill: "#fff",
    opacity: 0.25,
    style: {
      isolation: "isolate"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay32D7Baa8);
export default __webpack_public_path__ + "static/media/GooglePlay.32d7baa8.6ae5d3269435ddf578256c437a9ef6cd.svg";
export { ForwardRef as ReactComponent };